import {Helmet} from "react-helmet";
import {RouteHelper, RouteInfo} from "../../route/RouteHelper";
import PointsStatistics from "../../component/statistics/PointsStatistics";
import React, {useEffect, useRef, useState} from "react";
import "../dashboard/Dashboard.scss"
import {
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoBaseCardContainer,
    RaikoSectionContainer,
    RaikoGridTwoColumn,
    RaikoDatePicker,
    RaikoTableTitleContainer,
    RaikoCustomTable,
    showErrorMessage,
    RaikoDefaultDialogPage,
    DialogSize,
    RaikoShowPrice,
    RaikoFlexFirstChildGrowOne,
    RaikoButtonSecondary
} from "@moeindal/base-raiko-panel-components"
import {css} from "@emotion/css";
import useDraggableScroll from "use-draggable-scroll";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {UnionService} from "../../serverService/unionService/UnionService";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useAuthState} from "../../context/AuthContext";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {convertCurrencyFormat} from "../../util/numberConvertor";
import {useDebounce} from "@uidotdev/usehooks";
import UnionInfo from "./UnionInfo";
import {addNewRowToTable} from "../../util/TableProvider";
import {prev} from "stylis";


export default function UnionDetail() {


    //drag-start
    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});
    //drag-end
    let size = 20;
    const [page, setPage] = useState(0)

    const {id: fundId} = useParams()
    const {state} = useLocation()
    const [investment, setInvestment] = useState(state && state.title ? state.title : RouteHelper.UnionDetail.name)
    const loading = new LoadingHelper(useLoadingDispatcher())

    const service = new UnionService()


    const [startDateFilter, setStartDateFilter] = useState("");
    const [endDateFilter, setEndDateFilter] = useState("");
    const _startDateFilter = useDebounce(startDateFilter, 500);
    const _endDateFilter = useDebounce(endDateFilter, 500);


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getUnionBasicInformationFromServer()
            getTransactionListFromServer()
        }

    }, [_startDateFilter, _endDateFilter]);


    const [transactionsData, setTransactionsData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [transactionSummation, setTransactionSummation] = useState(0);
    const [reports, setReports] = useState({
        investmentMonths: 0,
        totalBalance: 0,
        totalCashBalance: 0,
        totalUnionBalance: 0,
        unionAverageBalance: 0,
    })


    function getUnionBasicInformationFromServer() {
        loading.show()
        service.getUnionBasicInformation(fundId).then(
            response => {
                setReports(response)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function tableTransactionPreparation(id, number, amount, date, createAt, createBy, fundId, fundName) {
        return {
            id: id,
            number: number,
            amount: <RaikoShowPrice amount={amount}/>,
            date: convertUniversalDateToPersianDate(date),
            createAt: convertUniversalDateToPersianDate(createAt),
            createBy: createBy,
            fundId: fundId,
            fundName: fundName,
        }
    }

    function getTransactionListFromServer() {
        setTableLoading(true)
        service.getUnionTransactionList(page, size, startDateFilter, endDateFilter, fundId).then(
            response => {
                setPageCount(response.totalPage)
                setTransactionSummation(response.summationOfAmounts)
                setTransactionsData([])
                response.data.map((item, index) => {
                    setTransactionsData(prevState => [
                        ...prevState,
                        tableTransactionPreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.amount,
                            item.date,
                            item.createAt,
                            item.createBy,
                            item.fundId,
                            item.fundName
                        )
                    ])
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    function handlePaginationChange(newPage) {
        setPage(newPage)
        getTransactionListFromServer()
    }

    //unionInfo
    const [openUnionInfoDialog, setOpenUnionInfoDialog] = useState(false);
    const [transactionId, setTransactionId] = useState(-1)

    function handleOpenDialog() {
        setOpenUnionInfoDialog(true)
    }

    function handleCloseDialog() {
        setOpenUnionInfoDialog(false)
        setTransactionId(-1)
    }

    function showUnion(rowId) {
        setTransactionId(rowId)
        setOpenUnionInfoDialog(true)
    }

    function handlePushTransactionToTable(item) {
        const newItems = addNewRowToTable(
            tableTransactionPreparation(
                item.id,
                item.id,
                item.amount,
                item.date,
                item.createAt,
                item.createBy,
                item.fundId,
                item.fundName
            ),
            transactionsData
        )
        setTransactionsData(newItems)
        handleCloseDialog()
    }

    function handleUpdateTransactionInTable(id, amount, date) {
        setTableLoading(true)
        const _transactionsData = transactionsData
        setTransactionsData([])
        _transactionsData.map((item, index) => {
            setTransactionsData(prev => [
                ...prev,
                {
                    ...item,
                    amount: item.id === id ? <RaikoShowPrice amount={amount}/> : item.amount,
                    date: item.id === id ? convertUniversalDateToPersianDate(date) : item.date,
                }
            ])
        })
        setTableLoading(false)
    }

    //unionInfo
    const navigate = useNavigate()

    return (
        <>
            <Helmet>
                <title>{RouteHelper.UnionDetail.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                dialogSize={DialogSize.WRAP_CONTENT}
                onClose={handleCloseDialog}
                pageTitle={transactionId >= 0 ? "جزئيات تراکنش سرمایه گذاری" : "افزودن تراکنش سرمایه گذاری"}
                open={openUnionInfoDialog}
            >
                <UnionInfo
                    transactionId={transactionId}
                    handleAddNewItem={handlePushTransactionToTable}
                    handleUpdateTransactionInTable={handleUpdateTransactionInTable}
                    handleCloseDialog={handleCloseDialog}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Union.name,
                                RouteHelper.Union.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                investment,
                                ""
                            )
                        ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>


                    </RaikoFlexFirstChildGrowOne>


                    <div className={"statisticsLayout hideScroll"} ref={ref} onMouseDown={onMouseDown}>
                        <PointsStatistics
                            title={"موجودی صندوق (ریال)"}
                            amount={convertCurrencyFormat(reports.totalCashBalance)}
                        />
                        <PointsStatistics
                            title={"موجودی نقدی صندوق (ریال)"}
                            amount={convertCurrencyFormat(reports.totalBalance)}
                        />
                        <PointsStatistics
                            title={"ماه سرمایه گذاری"}
                            amount={reports.investmentMonths}
                        />
                        <PointsStatistics
                            title={"مجموع سرمایه گذاری (ریال)"}
                            amount={convertCurrencyFormat(reports.totalUnionBalance)}
                        />
                        <PointsStatistics
                            title={"میانگین سرمایه گذاری (ریال)"}
                            amount={convertCurrencyFormat(reports.unionAverageBalance)}
                        />
                    </div>
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"جستجو"}
                        subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                    >
                        <RaikoGridTwoColumn>
                            <RaikoDatePicker
                                label={"تاریخ شروع"}
                                date={startDateFilter}
                                setDate={setStartDateFilter}/>
                            <RaikoDatePicker
                                label={"تاریخ پایان"}
                                date={endDateFilter}
                                setDate={setEndDateFilter}/>
                        </RaikoGridTwoColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"سابقه تراکنشات"}
                            hasCreateNewItem
                            handleCreateNewItem={showUnion}
                        />
                        <RaikoCustomTable
                            data={transactionsData}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            handlePaginationChange={handlePaginationChange}
                            header={unionDetailTableHeader}
                            summationOfAmount={transactionSummation}
                            rowClicked={showUnion}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

            </RaikoBaseContainer>
        </>
    )
}
export const unionDetailTableHeader = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
    },
    {
        id: 'date',
        label: 'تاریخ واریز',
    },
    {
        id: 'createAt',
        label: 'تاریخ ساخت',
    },
    {
        id: 'createBy',
        label: 'سازنده',
    },
]